import { Typography } from '@material-ui/core';
import React, { Component } from 'react';
import { ColorResult, SketchPicker } from 'react-color';
import hexToRgb from '../../lib/hexToRbg';
import rgbToHsl from '../../lib/rgbToHsl';
import { MaterialInput } from '../FormInput';
import { ColorBox, ColorPickerContainer, ColorSelectorContainer } from './styles';

interface IColorSelectorProps {
  title: string;
  color: string;
  onChange: (color: ColorResult) => void;
}

interface IColorSelectorState {
  showColorPicker: boolean;
  localColor: string;
}

class ColorSelector extends Component<IColorSelectorProps, IColorSelectorState> {

  private pickerRef: HTMLDivElement | null = null;

  constructor(props: IColorSelectorProps) {
    super(props);

    this.state = {
      showColorPicker: false,
      localColor: props.color,
    };
  }

  public componentDidMount() {
    window.addEventListener('mousedown', this.handleClick);
  }

  public componentWillUnmount() {
    window.addEventListener('mousedown', this.handleClick);
  }

  public componentWillReceiveProps(newProps: IColorSelectorProps) {
    if (this.state.localColor !== newProps.color) {
      this.setState({ localColor: newProps.color });
    }
  }

  public render() {
    const { title, color, onChange } = this.props;
    const { showColorPicker, localColor } = this.state;
    return (
      <ColorSelectorContainer>
        <Typography variant='subtitle1'>
          {title}
        </Typography>
        <MaterialInput
          style={{ margin: '0 12px', marginTop: '1.2rem' }}
          variant='outlined'
          value={localColor.toUpperCase()}
          onChange={e => this.setState({ localColor: e.target.value })}
          onBlur={() => this.parseHex(localColor)}
        />
        <div style={{ position: 'relative', marginLeft: 10 }}>
          <ColorBox color={color}
            onClick={() => this.toggleColorPicker()}
          />
          {showColorPicker && (
            <ColorPickerContainer
              ref={pickerElement => (this.pickerRef = pickerElement)}
            >
              <SketchPicker color={color} onChange={onChange} />
            </ColorPickerContainer>
          )}
        </div>

      </ColorSelectorContainer>
    );
  }

  private parseHex = (colorString: string) => {

    const rgb = hexToRgb(colorString);

    if (!rgb) {
      return;
    }

    const newColor: ColorResult = {
      hex: colorString,
      rgb,
      hsl: rgbToHsl(rgb),
    };

    this.props.onChange(newColor);
  }

  private handleClick = (e: Event) => {
    if (
      this.pickerRef &&
      !this.pickerRef.contains(e.target as Node)
    ) {
      this.setState({ showColorPicker: false });
    }
  }

  private toggleColorPicker = () => {
    this.setState((prevState) => ({
      showColorPicker: !prevState.showColorPicker,
    }));
  }
}

export default ColorSelector;
